<template>
  <p class="payment-condition-description m-0 caption">
    {{ t('travellers.modifyNotAllowedMessageBefore') }}
    <a href="mailto:support.uk@travelski.com" class="email-link">support.uk@travelski.com</a>
    {{ t('travellers.modifyNotAllowedMessageAfter') }}
  </p>
</template>

<script lang="ts" setup>
  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()
</script>

<style scoped>
  .email-link {
    color: var(--primary-blue, #007bff);
    text-decoration: underline;
    font-size: inherit;
    font-weight: inherit;
  }

  .email-link:hover {
    color: var(--primary-blue-dark, #0056b3);
    text-decoration: underline;
  }
</style> 